import { useEffect, useState } from "react";
import { BsFillPersonFill } from "react-icons/bs";
import { IoMdRefresh } from "react-icons/io";
import { Img } from "react-image";
import { useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import SweetAlert2 from "react-sweetalert2";
import { hideCompanyList } from "../../../constants/CommonConst";
import { checkIsIndoRegion, toAbsoluteUrl } from "../../../utils/CommonHelper";
import { useAuth } from "../../auth/components/AuthInit";
import * as actions from "../redux/HomeAction";

const Image = ({ className, imageUrl, name, onClick }) => {
  return (
    <div onClick={onClick}>
      <Img
        src={imageUrl}
        unloader={<img className={className} alt={name} src={imageUrl} />}
        className={className}
        alt={name}
        decode={false}
        loading="lazy"
        loader={
          <div style={{ position: "relative", width: "100%", height: "100%" }}>
            <div
              style={{
                position: "absolute",
                color: "white",
                fontSize: "2vh",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
                width: "100%",
              }}
            >
              {name}
            </div>
            <img
              src={toAbsoluteUrl("/image/defaultimage.avif?15895434")}
              alt={name}
              className="skeleton"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>
        }
      />
    </div>
  );
};

const GameItem = ({ game, handlePlayGame }) => {
  const intl = useIntl();
  const [isShowPlay, setIsShowPlay] = useState(false);

  return (
    <div className="mb-2" style={{ width: "23%" }}>
      <div
        className="rounded company-active position-relative"
        onMouseEnter={() => setIsShowPlay(true)}
        onMouseLeave={() => setIsShowPlay(false)}
      >
        <div>
          <img src={game.imageurl} alt={game.gamename} className="w-100 mb-2" />
          <div
            className="text-center text-truncate px-2 text-font1"
            style={{ color: "white" }}
          >
            {game.gamename}
          </div>
        </div>
        {isShowPlay && (
          <div
            className="position-absolute w-100 top-0 bottom-0 rounded d-flex flex-column align-items-center justify-content-center"
            style={{ background: "rgba(0,0,0,0.8)" }}
          >
            {/* <div className="text-center text-truncate px-2" style={{ color: 'white' }}>{game.gamename}</div> */}
            <button
              type="button"
              className="btn btn-info fw-bold text-font1"
              onClick={() =>
                handlePlayGame(game.gamecode, game.gametype, game.companycode)
              }
            >
              {intl.formatMessage({ id: "play" })}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export const Home = ({}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [category, setCategory] = useState("");
  const [categoryIndex, setCategoryIndex] = useState(0);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const [swalProps, setSwalProps] = useState({});
  const { urgentShow, setUrgentShow, auth } = useAuth();
  const isIndoRegion = checkIsIndoRegion(auth);
  const location = useLocation();
  const navigate = useNavigate();
  const [companyOffset, setCompanyOffset] = useState(
    location.state ? parseInt(location.state.companyOffset) : 0,
  );
  const homeState = useSelector(({ home }) => home, shallowEqual);
  const [isLoading, setIsLoading] = useState(false);

  const handleDepositClick = () => {
    navigate("/setting/deposit", { state: { backTo: "/home" } });
  };
  const handleTransferClick = () => {
    navigate("/setting/transfer", { state: { backTo: "/home" } });
  };
  const handleWithdrawClick = () => {
    navigate("/setting/withdraw", { state: { backTo: "/home" } });
  };
  const handlePlayGame = (gameCode, gameType, companyCode) => {
    let playType;
    if (gameType === "slot") {
      playType = 1;
    } else if (gameType === "live") {
      playType = 2;
    } else if (gameType === "fishing") {
      playType = 3;
    } else if (gameType === "sport") {
      playType = 4;
    }
    const currentScrollPosition =
      window.scrollY || document.documentElement.scrollTop;
    navigate(
      `/gamePlay/${companyCode}/${gameCode}/${companyOffset}/${currentScrollPosition}/${playType}`,
    );
  };
  useEffect(() => {
    if (sessionStorage.getItem("platform") === "mobile") {
      console.log(`memberid: ${auth.memberid}`);
    }
  }, []);

  useEffect(() => {
    if (location.state && location.state.gameType) {
      if (location.state.gameType === "live") {
        setCategory("live");
        setCategoryIndex(1);
      } else if (location.state.gameType === "app") {
        setCategory("app");
        setCategoryIndex(2);
      } else if (location.state.gameType === "fishing") {
        setCategory("fishing");
        setCategoryIndex(3);
      } else if (location.state.gameType === "sport") {
        setCategory("sport");
        setCategoryIndex(4);
      } else if (location.state.gameType === "lottery") {
        setCategory("lottery");
        setCategoryIndex(5);
      } else {
        setCategory("slot");
        setCategoryIndex(0);
      }
    } else {
      setCategory("slot");
    }
  }, []);

  useEffect(() => {
    const params = {
      strMemberID: auth.memberid,
      strLoginID: auth.loginid,
      strCurrencyCode: auth.currencycode,
    };
    dispatch(actions.getHomePageUI(params));
  }, []);

  useEffect(() => {
    if (!isIndoRegion && !urgentShow) {
      const imageUrl = toAbsoluteUrl(`image/urgent.webp`);
      setSwalProps({
        show: true,
        showCloseButton: true,
        showConfirmButton: false,
        closeButtonHtml: `<div><button class="btn btn-danger rounded-circle p-0 d-flex align-items-center justify-content-center" style="width:30px;height:30px;"><div style="padding-bottom:2px"><i class="bi bi-x fs-4"/></div></button></div>`,
        html: `<div class="d-flex flex-column"><img class="w-100" src="${imageUrl}"/><div class="announcement mt-4 text-start">
  <p><strong>Urgent!</strong> Nombor 60189010731 telah dihentikan penggunaannya. Sila hubungi nombor baharu kami 60176814148.</p>

  <p>Kepada pelanggan yang dihormati,</p>

  <p>Bagi meningkatkan kecekapan komunikasi dan pengalaman perkhidmatan, nombor WhatsApp khidmat pelanggan kami yang sedia ada, <strong>60176814148</strong>, telah dihentikan. Mulai hari ini, sila simpan dan gunakan nombor WhatsApp khidmat pelanggan yang baharu:</p>

  <p><strong>Nombor baharu:</strong> 60176814148<br>
  <strong>Pautan cepat untuk menghubungi:</strong><br>
  <a href="https://wa.me/60176814148?text=Hi%20I%20would%20like%20to%20ask%20something" target="_blank">
    https://wa.me/60176814148?text=Hi%20I%20would%20like%20to%20ask%20something
  </a>
  </p>

  <p>Sekiranya anda pernah menghubungi kami melalui nombor lama, sila pastikan nombor baharu telah ditambahkan ke dalam senarai kenalan anda supaya anda dapat menerima sokongan khidmat pelanggan tepat pada masanya. Maaf atas sebarang kesulitan yang disebabkan.</p>

  <p>Terima kasih atas kefahaman dan kerjasama anda!</p>

  <p>[279rc.com]<br>[24/04/2026 19:00]</p>

  <hr>

  <p><strong>尊敬的客户：</strong></p>

  <p>您好！60189010731已停止使用，请联系新号码60176814148</p>

  <p>为提升沟通效率与服务体验，我们现有的客服WhatsApp号码 <strong>60176814148</strong> 已停止使用。即日起，请您保存并使用新的客服WhatsApp号码：</p>

  <p><strong>新号码：</strong>60176814148<br>
  <strong>快捷联系链接：</strong><br>
  <a href="https://wa.me/60176814148?text=Hi%20I%20would%20like%20to%20ask%20something" target="_blank">
    https://wa.me/60176814148?text=Hi%20I%20would%20like%20to%20ask%20something
  </a>
  </p>

  <p>若您之前曾通过旧号码与我们联系，请务必将新号码添加至通讯录，以便后续及时获取客服支持。由此带来的不便，敬请谅解。</p>

  <p>感谢您的理解与配合！</p>

  <p>[279rc.com]<br>[24/04/2026 19:00]</p>
</div></div>`,
      });
      setUrgentShow(true);
    }
  }, []);

  useEffect(() => {
    if (homeState.homePageUI) {
      const params = {
        strMemberID: auth.memberid,
        strLoginID: auth.loginid,
        strCurrencyCode: auth.currencycode,
      };
      dispatch(actions.getHomePageMemberData(params));
      dispatch(actions.getHistory());
      const intervalId = setInterval(() => {
        setCurrentBannerIndex(
          (prevIndex) =>
            (prevIndex + 1) % homeState.homePageUI.topBannerLists.length,
        );
      }, 3000);
      return () => clearInterval(intervalId);
    }
  }, [homeState.homePageUI]);

  const handleCategoryClick = (index, category) => {
    setCategoryIndex(index);
    setCategory(category);
  };
  const handleRefreshData = () => {
    setIsLoading(true);

    const params = {
      strMemberID: auth.memberid,
      strLoginID: auth.loginid,
      strCurrencyCode: auth.currencycode,
    };

    dispatch(actions.getHomePageMemberData(params));

    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  const handlePullUpRefresh = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (categoryIndex === 6) {
          setCategoryIndex(6);
        } else if (categoryIndex === 0) {
          setCategoryIndex((prevIndex) => prevIndex + 1);
          setCategory("live");
        } else if (categoryIndex === 1) {
          setCategoryIndex((prevIndex) => prevIndex + 1);
          setCategory("app");
        } else if (categoryIndex === 3) {
          setCategoryIndex((prevIndex) => prevIndex + 1);
          setCategory("fishing");
        } else if (categoryIndex === 4) {
          setCategoryIndex((prevIndex) => prevIndex + 1);
          setCategory("sport");
        } else if (categoryIndex === 5) {
          setCategoryIndex((prevIndex) => prevIndex + 1);
          setCategory("lottery");
        }
        resolve();
      }, 100);
    });
  };
  const handleRefresh = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (categoryIndex === 0) {
          setCategoryIndex(0);
        } else if (categoryIndex === 1) {
          setCategoryIndex((prevIndex) => prevIndex - 1);
          setCategory("slot");
        } else if (categoryIndex === 2) {
          setCategoryIndex((prevIndex) => prevIndex - 1);
          setCategory("live");
        } else if (categoryIndex === 3) {
          setCategoryIndex((prevIndex) => prevIndex - 1);
          setCategory("app");
        } else if (categoryIndex === 4) {
          setCategoryIndex((prevIndex) => prevIndex - 1);
          setCategory("fishing");
        } else if (categoryIndex === 5) {
          setCategoryIndex((prevIndex) => prevIndex - 1);
          setCategory("sport");
        }
        resolve();
      }, 100);
    });
  };
  const handleItemClick = (companyCode, gametype) => {
    navigate(
      gametype === "lottery" ? `/${gametype}` : `/${gametype}/${companyCode}`,
    );
  };

  return (
    <div
      style={{
        backgroundColor: "black",
        backgroundImage: `url(${toAbsoluteUrl(
          "/image/homebackground.avif?65464234",
        )})`,
        backgroundSize: "cover",
        minHeight: "93.5vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <div style={{ height: "30%", width: "100%" }}>
        {homeState.homePageUI &&
          homeState.homePageUI.topBannerLists.length > 0 && (
            <>
              <img
                src={
                  homeState.homePageUI.topBannerLists[currentBannerIndex]
                    .imagename
                }
                alt={`Banner ${currentBannerIndex + 1}`}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </>
          )}
      </div>
      <div>
        <div
          style={{
            display: "flex",
            margin: "0 auto",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "98%",
              borderRadius: "10px",
              border: "1px solid grey",
              backgroundColor: "#181818",
            }}
          >
            <div
              style={{
                width: "95%",
                display: "flex",
                borderBottom: "1px solid grey",
                backgroundColor: "#181818",
                padding: "5px",
                marginLeft: "5px",
                marginRight: "5px",
              }}
            >
              <div
                style={{
                  width: "20px",
                  height: "15px",
                  backgroundColor: "rgb(245, 190, 9)",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  className="text-font4"
                  style={{
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  !
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginRight: "5px",
                  width: "100%",
                }}
              >
                {homeState.homePageUI &&
                  homeState.homePageUI.topBannerLists && (
                    <marquee
                      className="text-font3"
                      behavior="scroll"
                      direction="left"
                      style={{ color: "white" }}
                    >
                      {homeState.homePageUI.anncouncement}
                    </marquee>
                  )}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                paddingLeft: "5px",
                alignItems: "center",
              }}
            >
              <span
                className="text-font4"
                style={{ color: "white", paddingLeft: "5px" }}
              >
                {intl.formatMessage({ id: "welcome" })}
              </span>
              <span
                className="text-font4"
                style={{ color: "rgb(245, 190, 9)" }}
              >
                {auth.username}
              </span>
              {!isLoading && (
                <span style={{ marginLeft: "5px" }} onClick={handleRefreshData}>
                  <IoMdRefresh color="white" size={15} />
                </span>
              )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "5px",
              }}
            >
              <div
                style={{ flex: 1, display: "flex", justifyContent: "center" }}
              >
                <BsFillPersonFill
                  style={{ color: "white", fontSize: "45px" }}
                />
              </div>
              <div
                style={{
                  flex: 3,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <span className="text-font2" style={{ color: "white" }}>
                    {auth.currencycode}
                  </span>
                  <span className="text-font2" style={{ color: "white" }}>
                    {intl.formatMessage({ id: "bonus" })}
                  </span>
                  <span className="text-font2" style={{ color: "white" }}>
                    {intl.formatMessage({ id: "game" })}
                  </span>
                </div>
                {homeState.homePageMemberData ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <span className="text-font2" style={{ color: "white" }}>
                      &nbsp;: &nbsp;
                      {isLoading ? "-" : homeState.homePageMemberData.balance}
                    </span>
                    <span className="text-font2" style={{ color: "white" }}>
                      &nbsp;: &nbsp;
                      {isLoading ? "-" : homeState.homePageMemberData.bonus}
                    </span>
                    <span className="text-font2" style={{ color: "white" }}>
                      &nbsp;: &nbsp;
                      {isLoading
                        ? "-"
                        : homeState.homePageMemberData.gamebalance}
                    </span>
                  </div>
                ) : (
                  <Skeleton className="w-100" height="600px" />
                )}
              </div>
              <div style={{ flex: 1 }}></div>
              <div
                onClick={handleDepositClick}
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div style={{ width: "30px", height: "30px" }}>
                    <img
                      src={toAbsoluteUrl(`/image/deposit.avif?89789323`)}
                      style={{ width: "30px", height: "30px" }}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <span className="text-font1" style={{ color: "white" }}>
                    {intl.formatMessage({ id: "deposit" })}
                  </span>
                </div>
              </div>
              <div
                onClick={handleTransferClick}
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div style={{ width: "30px", height: "30px" }}>
                    <img
                      src={toAbsoluteUrl(`/image/transfer.avif?7894367234`)}
                      style={{ width: "30px", height: "30px" }}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <span className="text-font1" style={{ color: "white" }}>
                    {intl.formatMessage({ id: "transfer" })}
                  </span>
                </div>
              </div>
              <div
                onClick={handleWithdrawClick}
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div style={{ width: "30px", height: "30px" }}>
                    <img
                      src={toAbsoluteUrl(`/image/withdraw.avif?89124335`)}
                      style={{ width: "30px", height: "30px" }}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <span className="text-font1" style={{ color: "white" }}>
                    {intl.formatMessage({ id: "withdraw" })}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            paddingTop: "5px",
            height: "62vh",
            marginBottom: "7vh",
          }}
        >
          <div
            style={{
              width: "18%",
              float: "left",
              overflowY: "auto",
              paddingLeft: "5px",
            }}
          >
            {homeState.homePageMemberData &&
            homeState.homePageMemberData.historyshow === "true" ? (
              <div>
                <div onClick={() => handleCategoryClick(6, "history")}>
                  <img
                    src={
                      categoryIndex === 6
                        ? toAbsoluteUrl(`/image/history1.avif?67283412343`)
                        : toAbsoluteUrl(`/image/history.avif?178412323`)
                    }
                    alt="Slot"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div style={{ height: "5px" }}></div>
                <div onClick={() => handleCategoryClick(0, "slot")}>
                  <img
                    src={
                      categoryIndex === 0
                        ? toAbsoluteUrl(`/image/slot1.avif?179843535`)
                        : toAbsoluteUrl(`/image/slot.avif?391780345`)
                    }
                    alt="Slot"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div style={{ height: "5px" }}></div>
                <div onClick={() => handleCategoryClick(1, "live")}>
                  <img
                    src={
                      categoryIndex === 1
                        ? toAbsoluteUrl(`/image/live1.avif?13454356`)
                        : toAbsoluteUrl(`/image/live.avif?7266254`)
                    }
                    alt="Live Casino"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div style={{ height: "5px" }}></div>
                <div onClick={() => handleCategoryClick(2, "app")}>
                  <img
                    src={
                      categoryIndex === 2
                        ? toAbsoluteUrl(`/image/app1.avif?6718334`)
                        : toAbsoluteUrl(`/image/app.avif?2189535`)
                    }
                    alt="App"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                {homeState.homePageUI?.gameTypeLists
                  ?.find((gameType) => gameType.gametype === "fishing")
                  ?.companyGameLists?.filter(
                    (game) =>
                      !isIndoRegion ||
                      !hideCompanyList.includes(game.companycode),
                  ).length > 0 && (
                  <>
                    <div style={{ height: "5px" }}></div>
                    <div onClick={() => handleCategoryClick(3, "fishing")}>
                      <img
                        src={
                          categoryIndex === 3
                            ? toAbsoluteUrl(`/image/fishing1.avif?9754353`)
                            : toAbsoluteUrl(`/image/fishing.avif?3153457`)
                        }
                        alt="Fishing"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </>
                )}
                <div style={{ height: "5px" }}></div>
                <div onClick={() => handleCategoryClick(4, "sport")}>
                  <img
                    src={
                      categoryIndex === 4
                        ? toAbsoluteUrl(`/image/sport1.avif?6785643521`)
                        : toAbsoluteUrl(`/image/sport.avif?21354646`)
                    }
                    alt="Sport"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                {!isIndoRegion && (
                  <>
                    <div style={{ height: "5px" }}></div>
                    <div onClick={() => handleCategoryClick(5, "lottery")}>
                      <img
                        src={
                          categoryIndex === 5
                            ? toAbsoluteUrl(`/image/lottery1.avif?23178534`)
                            : toAbsoluteUrl(`/image/lottery.avif?3143546`)
                        }
                        alt="Lottery"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </>
                )}
                <div style={{ height: "5px" }}></div>
              </div>
            ) : (
              <div>
                <div onClick={() => handleCategoryClick(0, "slot")}>
                  <img
                    src={
                      categoryIndex === 0
                        ? toAbsoluteUrl(`/image/slot1.avif?12378545`)
                        : toAbsoluteUrl(`/image/slot.avif?74676278`)
                    }
                    alt="Slot"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div style={{ height: "5px" }}></div>
                <div onClick={() => handleCategoryClick(1, "live")}>
                  <img
                    src={
                      categoryIndex === 1
                        ? toAbsoluteUrl(`/image/live1.avif?76567575`)
                        : toAbsoluteUrl(`/image/live.avif?65464452`)
                    }
                    alt="Live Casino"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div style={{ height: "5px" }}></div>
                <div onClick={() => handleCategoryClick(2, "app")}>
                  <img
                    src={
                      categoryIndex === 2
                        ? toAbsoluteUrl(`/image/app1.avif?65463544`)
                        : toAbsoluteUrl(`/image/app.avif?123954654`)
                    }
                    alt="App"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                {homeState.homePageUI?.gameTypeLists
                  ?.find((gameType) => gameType.gametype === "fishing")
                  ?.companyGameLists?.filter(
                    (game) =>
                      !isIndoRegion ||
                      !hideCompanyList.includes(game.companycode),
                  ).length > 0 && (
                  <>
                    <div style={{ height: "5px" }}></div>
                    <div onClick={() => handleCategoryClick(3, "fishing")}>
                      <img
                        src={
                          categoryIndex === 3
                            ? toAbsoluteUrl(`/image/fishing1.avif?54645652342`)
                            : toAbsoluteUrl(`/image/fishing.avif?2315464`)
                        }
                        alt="Fishing"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </>
                )}
                <div style={{ height: "5px" }}></div>
                <div onClick={() => handleCategoryClick(4, "sport")}>
                  <img
                    src={
                      categoryIndex === 4
                        ? toAbsoluteUrl(`/image/sport1.avif?31675765`)
                        : toAbsoluteUrl(`/image/sport.avif?7676345345`)
                    }
                    alt="Sport"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                {!isIndoRegion && (
                  <>
                    <div style={{ height: "5px" }}></div>
                    <div onClick={() => handleCategoryClick(5, "lottery")}>
                      <img
                        src={
                          categoryIndex === 5
                            ? toAbsoluteUrl(`/image/lottery1.avif?32546543`)
                            : toAbsoluteUrl(`/image/lottery.avif?213464657`)
                        }
                        alt="Lottery"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </>
                )}
                <div style={{ height: "5px" }}></div>
              </div>
            )}
          </div>

          <div
            style={{
              width: "80%",
              float: "right",
              paddingLeft: "5px",
              paddingRight: "5px",
              overflowY: "auto",
              margin: "0 auto",
            }}
          >
            <PullToRefresh
              onRefresh={handleRefresh}
              onPullUp={handlePullUpRefresh}
              threshold={100}
            >
              {category === "history" ? (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent:
                      homeState.homePageHistoryList &&
                      homeState.homePageHistoryList.mbHomePageHistoryLists.filter(
                        (game) =>
                          !isIndoRegion ||
                          !hideCompanyList.includes(game.companycode),
                      ).length %
                        4 ===
                        2
                        ? "center"
                        : "flex-start",
                    columnGap: "calc(8% / 3)",
                  }}
                >
                  {homeState.homePageHistoryList &&
                    homeState.homePageHistoryList.mbHomePageHistoryLists
                      .filter(
                        (game) =>
                          !isIndoRegion ||
                          !hideCompanyList.includes(game.companycode),
                      )
                      .map((historyGameLists, index) => (
                        <GameItem
                          key={index}
                          game={historyGameLists}
                          handlePlayGame={handlePlayGame}
                        />
                      ))}
                </div>
              ) : (
                homeState.homePageUI &&
                homeState.homePageUI.gameTypeLists
                  .filter((gameType) => gameType.gametype === category)
                  .map((filteredGameType, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      {filteredGameType.companyGameLists &&
                        filteredGameType.companyGameLists
                          .filter(
                            (game) =>
                              !isIndoRegion ||
                              !hideCompanyList.includes(game.companycode),
                          )
                          .map((game, gameIndex) => (
                            <div key={gameIndex}>
                              <Image
                                className="custom-image"
                                imageUrl={game.imageurl}
                                alt={game.companyname}
                                name={game.companyname}
                                onClick={() =>
                                  handleItemClick(
                                    game.companycode,
                                    filteredGameType.gametype,
                                  )
                                }
                              />

                              <div style={{ height: "5px" }}></div>
                            </div>
                          ))}
                    </div>
                  ))
              )}
            </PullToRefresh>
          </div>
        </div>
      </div>
    </div>
  );
};
